import { useAppSelector } from '../app/hooks'
import { InitState } from '../redux/reducers/root/initialState'
import { SegmentationType } from '../@types/types'
import { useMemo } from 'react'
import { useTranslation, UseTranslationOptions } from 'react-i18next'

export function useTooltipTranslation(options?: UseTranslationOptions<undefined>) {
  const namespace = useTooltipNameSpace()
  return useTranslation(namespace, options)
}

export function useTooltipNameSpace(): string {
  const segmentationType = useAppSelector((state: InitState) => state.flowFeature.flowInformation.metaData.segmentation)
  return useMemo(() => (segmentationType === SegmentationType.AGENT ? 'professional' : 'private'), [segmentationType])
}
